import { render, staticRenderFns } from "./HeadView.vue?vue&type=template&id=6650c12b&scoped=true&"
import script from "./HeadView.vue?vue&type=script&lang=js&"
export * from "./HeadView.vue?vue&type=script&lang=js&"
import style0 from "./HeadView.vue?vue&type=style&index=0&id=6650c12b&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6650c12b",
  null
  
)

export default component.exports